import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import{BrowserRouter} from "react-router-dom"
import { StateProvider } from './Hooks/stateProvider';
import reducer, { initialState } from './Hooks/reducer';
import axios from "axios";
import { URL } from './variables';

axios.defaults.baseURL = "https://pms-api.apmiindia.org/pms";
// axios.defaults.baseURL = "http://localhost:40048/pms";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
    <BrowserRouter >
      <StateProvider initialState={initialState} reducer={reducer}>
        <App />
      </StateProvider>
    </BrowserRouter>
  </>
);

